const e = "styles-module__textarea___XDjE-", t = {
  textarea: e,
  "textarea--error": "styles-module__textarea--error___afq08",
  "textarea--valid": "styles-module__textarea--valid___mhKzt"
};
export {
  t as default,
  e as textarea
};
